import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {CustomsValidators} from '../../validators/custom.validators';


@Injectable({
  providedIn: 'root'
})
export class NewAccessCardService {
  urlNewCard: string;
  urlNewCardlist: string;
  urlGetReplacement: string;
  urlCardDetail: string;

  constructor(private http: HttpClient) {
    this.urlNewCard = `${environment.bffBaseUrl}/pages/card-form`;
    this.urlNewCardlist = `${environment.bffBaseUrl}/pages/card-list`;
    this.urlCardDetail = `${environment.bffBaseUrl}/pages/card-detail`;
    this.urlGetReplacement = `${environment.bffBaseUrl}/pages/card-replacement`;
  }

  getallsitespickups() {
    const urlBuilder = this.urlNewCard;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getallsitespickupsmotive() {
    const urlBuilder = this.urlGetReplacement;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getallcards(page, limit, filterUrl) {
    const urlBuilder = `${this.urlNewCardlist}?page=${page}&limit=${limit}${filterUrl}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getCardResult(id) {
    const urlBuilder = `${this.urlNewCard}/${id}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getCardConfirm(id) {
    const urlBuilder = `${this.urlCardDetail}/${id}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  // --POST
  postnewcard(cardRequest): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('PickupId', cardRequest.PickupId);
    if (cardRequest.MotiveId) {
      formData.append('MotiveId', cardRequest.MotiveId);
      formData.append('Type', 'false');
    } else {
      formData.append('Type', 'true');
    }
    formData.append('SiteId', cardRequest.SiteId);
    if (cardRequest.Bulk) {
      formData.append('Bulk', cardRequest.Bulk);
      let i = 0;
      for (const person of cardRequest.People) {
        if (person.ImageFile) {
          formData.append('Image_' + i, person.ImageFile, person.MDMID);
        }
        i++;
      }
    }
    formData.append('People', JSON.stringify(cardRequest.People));

    const urlBuilder = this.urlNewCard;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, formData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(this.errorMgmt)
    ) : throwError(CustomsValidators.msgNotValidUrl);
  }

  errorMgmt(error: HttpErrorResponse) {
    return throwError(error.error);
  }
}
